import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    IconBuildingStore,
    IconShoppingCart
} from '@tabler/icons-react';
import { usePreference } from '../context/PreferenceContext';

const RoleToggle = () => {
    const { t } = usePreference();
    const navigate = useNavigate();
    const location = useLocation();

    const actualRole = localStorage.getItem("role");

    const getCurrentValue = () => {
        const path = location.pathname;
        if (path.startsWith('/admin'))  return actualRole === 'superadmin' ? 'superadmin' : 'admin';
        if (path.startsWith('/seller')) return 'seller';
        if (path.startsWith('/buyer'))  return 'user';
        return 'user';
    };

    const currentValue = getCurrentValue();

    const allRoles = [
        { label: t('seller'), value: 'seller', icon: <IconBuildingStore size={16} />, path: '/seller/dashboard' },
        { label: t('buyer'),  value: 'user',   icon: <IconShoppingCart  size={16} />, path: '/buyer/dashboard'  },
    ];

    const getAvailableRoles = () => {
        if (actualRole === 'superadmin') return allRoles;
        if (actualRole === 'admin')      return allRoles.filter(r => r.value !== 'superadmin');
        if (actualRole === 'seller')     return allRoles.filter(r => ['seller', 'user'].includes(r.value));
        return [];
    };

    if (actualRole !== 'seller') return null;

    const availableRoles = getAvailableRoles();
    if (availableRoles.length <= 1) return null;

    return (
        <div className="role-toggle-shell">
            <span className="role-toggle-label">Switch View</span>
            <div className="role-toggle-group">
                {availableRoles.map(role => {
                    const isActive = currentValue === role.value;
                    return (
                        <button
                            key={role.value}
                            className={`role-toggle-btn ${isActive ? 'active' : ''}`}
                            onClick={() => { if (!isActive) navigate(role.path); }}
                        >
                            <span className="role-btn-icon">{role.icon}</span>
                            <span className="role-btn-label">{role.label}</span>
                            {isActive && <span className="role-btn-dot" />}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default RoleToggle;
